/** CrashClaw 工作区列表项（listWorkspaces 响应）公共字段 */
import useZuStore from 'store/zustand/zustand-store';
/** 前端展示名：优先用后端 displayName，兼容旧接口 */
export function getWorkspaceDisplayName(ws) {
    return ws.displayName || ws.workspaceName;
}
/** 是否为当前用户自己创建的工作区（未返回 isOwner 时按自有处理，兼容旧接口） */
export function isWorkspaceOwner(ws) {
    return ws.isOwner !== false;
}
/** 改名后的展示名：共享工作区保留“创建者 RTX 前 8 位-”前缀 */
export function buildWorkspaceDisplayName(ws, workspaceName) {
    if (isWorkspaceOwner(ws) || !ws.ownerRtx) {
        return workspaceName;
    }
    return `${ws.ownerRtx.slice(0, 8)}-${workspaceName}`;
}
/** 是否可管理工作区配置/共享（所有者，或 sharing.managers 对应的 MANAGER） */
export function canManageWorkspace(ws) {
    return isWorkspaceOwner(ws) || ws.accessRole === 'MANAGER';
}
/** 打开 CrashClaw 配置页；传入 workspaceUid 时自动弹出该工作区详情 Modal */
export function buildCrashClawConfigUrl(workspaceUid) {
    const params = new URLSearchParams({ tag: 'crashClawConfig' });
    if (workspaceUid) {
        params.set('workspaceUid', workspaceUid);
    }
    return `/account/profile?${params.toString()}`;
}
/** 工作区列表变更后通知 CrashClaw 对话页刷新（创建/删除工作区） */
export function notifyCrashClawWorkspacesChanged() {
    useZuStore.getState().aiDrawer.refreshCrashClawWorkspaces();
}
